export default __webpack_public_path__ + "static/glpbg-1265d61d89853d9ed9f037609abb89ad.png";